import { useState, useEffect } from "react";
import NavDropdown from "react-bootstrap/NavDropdown";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../styles/cookieconsent.css";

function ThemeChanger() {
  const [currentTheme, setCurrentTheme] = useState(
    localStorage.getItem("theme") || "auto"
  );

  const getPreferredTheme = () => {
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme) {
      return storedTheme;
    }
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  };

  const setTheme = (theme) => {
    if (theme === "auto") {
      document.documentElement.setAttribute(
        "data-bs-theme",
        window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "dark"
          : "light"
      );
      window.matchMedia("(prefers-color-scheme: dark)").matches
        ? (() => (
            document.body.classList.add("cc--dark-turquoise"),
            document.body.classList.remove("cc--light-turquoise")
          ))()
        : (() => (
            document.body.classList.add("cc--light-turquoise"),
            document.body.classList.remove("cc--dark-turquoise")
          ))();
    } else {
      document.documentElement.setAttribute("data-bs-theme", theme);
      theme === "dark"
        ? document.body.classList.add("cc--dark-turquoise")
        : document.body.classList.remove("cc--dark-turquoise");
      theme === "light"
        ? document.body.classList.add("cc--light-turquoise")
        : document.body.classList.remove("cc--light-turquoise");
    }
    localStorage.setItem("theme", theme);
    setCurrentTheme(theme);
  };

  useEffect(() => {
    // Set initial theme
    setTheme(getPreferredTheme());

    // Add listener for system theme changes
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = () => {
      if (currentTheme === "auto") {
        setTheme("auto");
      }
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [currentTheme]);

  const getThemeIcon = (theme) => {
    switch (theme) {
      case "light":
        return "bi-sun-fill";
      case "dark":
        return "bi-moon-stars-fill";
      case "auto":
      default:
        return "bi-circle-half";
    }
  };

  return (
    <NavDropdown
      title={<i className={`bi ${getThemeIcon(currentTheme)}`} />}
      id="theme-dropdown"
      className="nav-item dropdown pl-2 hover:"
    >
      <NavDropdown.Item
        onClick={() => setTheme("light")}
        active={currentTheme === "light"}
        className="d-flex align-items-center gap-2"
      >
        <i className="bi bi-sun-fill"></i> Light
      </NavDropdown.Item>
      <NavDropdown.Item
        onClick={() => setTheme("dark")}
        active={currentTheme === "dark"}
        className="d-flex align-items-center gap-2"
      >
        <i className="bi bi-moon-stars-fill"></i> Dark
      </NavDropdown.Item>
      <NavDropdown.Item
        onClick={() => setTheme("auto")}
        active={currentTheme === "auto"}
        className="d-flex align-items-center gap-2"
      >
        <i className="bi bi-circle-half"></i> System
      </NavDropdown.Item>
    </NavDropdown>
  );
}

export default ThemeChanger;
